<template>
  <a-transfer
    :data-source="dataSource"
    :titles="['未选择', '已选择']"
    :filter-option="filterOption"
    :target-keys="currentTargetKeys"
    :render="item => item.title"
    show-search
    @change="handleChange"
  />
</template>
<script>
export default {
  props: {
    dataSource: {
      type: Array,
      required: true,
      default: () => [],
    },
    targetKeys: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      currentTargetKeys: this.targetKeys,
    };
  },
  watch: {
    targetKeys: {
      immediate: true,
      handler(newVal) {
        this.currentTargetKeys = newVal || [];
      },
    },
  },
  methods: {
    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1;
    },
    handleChange(targetKeys) {
      this.currentTargetKeys = targetKeys;
      this.$emit('change', targetKeys);
    },
  },
};
</script>
